import { useEffect } from 'react';

const SEO_CONFIG = {
  home: {
    title: 'iSoret — Digital Coupon Cards with Assured Cashback & Deals | India',
    description: "Discover India's trusted digital coupon marketplace. Buy Bronze, Silver & Gold coupon cards with guaranteed cashback and verified partner brand deals. 100% assured payout — no chance, no gambling.",
    canonical: 'https://isoret.com/home',
  },
  coupons: {
    title: 'Browse Coupon Deals & Cashback Cards | iSoret',
    description: 'Explore verified partner brand coupons with assured cashback and discounts. Filter by categories: electronics, fashion, food, lifestyle & travel on iSoret.',
    canonical: 'https://isoret.com/coupons',
  },
  faq: {
    title: 'Frequently Asked Questions & Answers | iSoret',
    description: 'Got questions about how iSoret coupon cards and cashback work? Read our FAQ on tiers, 48-hour wallet payouts, redemption, and zero-gambling guarantee.',
    canonical: 'https://isoret.com/faq',
  },
  about: {
    title: 'About iSoret — India\'s Assured Cashback Marketplace | FLUX INFOTECH',
    description: 'Learn about iSoret, operated by FLUX INFOTECH LLP. Our mission is to empower shoppers with guaranteed cashback, transparent savings, and exclusive discounts.',
    canonical: 'https://isoret.com/about',
  },
  contact: {
    title: 'Contact Us & Customer Support | iSoret Office',
    description: 'Reach out to the iSoret support team. Call +91 8369 693 745 or email isoret.server@gmail.com. Located in Thane, Maharashtra, India.',
    canonical: 'https://isoret.com/contact',
  },
  wallet: {
    title: 'My Wallet & Cashback Payouts | iSoret',
    description: 'Track your assured cashback earnings, wallet balance, and secure payout history on iSoret.',
    canonical: 'https://isoret.com/wallet',
  },
  login: {
    title: 'Sign In to Your Account | iSoret',
    description: 'Log in to your iSoret account to manage coupon cards, check cashback rewards, and redeem exclusive deals.',
    canonical: 'https://isoret.com/login',
  },
  signup: {
    title: 'Create an Account & Start Saving | iSoret',
    description: 'Sign up for free on iSoret to unlock Bronze, Silver, and Gold coupon cards with assured cashback.',
    canonical: 'https://isoret.com/signup',
  },
  profile: {
    title: 'My Profile & Account Settings | iSoret',
    description: 'Manage your profile details, contact preferences, and secure credentials on iSoret.',
    canonical: 'https://isoret.com/profile',
  },
  checkout: {
    title: 'Secure Checkout | iSoret Coupon Cards',
    description: 'Complete your purchase of digital coupon cards securely with instant activation and assured cashback.',
    canonical: 'https://isoret.com/checkout',
  },
  'my-coupon': {
    title: 'My Purchased Coupon Cards | iSoret',
    description: 'Access all your active digital coupon cards and unlock guaranteed cashback on partner brand stores.',
    canonical: 'https://isoret.com/my-coupon',
  },
  'redeemed-coupons': {
    title: 'Redeemed Coupons & Savings History | iSoret',
    description: 'Review your redeemed coupons, brand discount vouchers, and recorded cashback payouts.',
    canonical: 'https://isoret.com/redeemed-coupons',
  },
  terms: {
    title: 'Terms & Conditions | iSoret Policy',
    description: 'Official terms and conditions for buying and redeeming digital coupon cards on iSoret (FLUX INFOTECH LLP).',
    canonical: 'https://isoret.com/terms',
  },
  privacy: {
    title: 'Privacy Policy & Data Security | iSoret',
    description: 'Read the privacy policy of iSoret. We protect user information with industry-standard security and zero third-party data selling.',
    canonical: 'https://isoret.com/privacy',
  },
  refund: {
    title: 'Refund Policy | iSoret Digital Coupons',
    description: 'Details and terms regarding digital coupon card purchases, returns, and refund guidelines on iSoret.',
    canonical: 'https://isoret.com/refund',
  },
  cancellation: {
    title: 'Cancellation Policy | iSoret',
    description: 'Read the account and order cancellation terms and procedures on iSoret.',
    canonical: 'https://isoret.com/cancellation',
  },
};

/**
 * Pure React SEO manager component that dynamically updates document title,
 * canonical link, meta descriptions, Open Graph, and Twitter metadata per route.
 */
export default function SEO({ currentPage = 'home' }) {
  useEffect(() => {
    const config = SEO_CONFIG[currentPage] || SEO_CONFIG.home;

    // 1. Update Document Title
    if (config.title) {
      document.title = config.title;
    }

    // Helper to safely set meta tag content
    const setMetaTag = (attrName, attrValue, content) => {
      let el = document.querySelector(`meta[${attrName}="${attrValue}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attrName, attrValue);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    // 2. Update Primary Meta Description
    if (config.description) {
      setMetaTag('name', 'description', config.description);
      setMetaTag('property', 'og:description', config.description);
      setMetaTag('name', 'twitter:description', config.description);
    }

    // 3. Update OG & Twitter Titles
    if (config.title) {
      setMetaTag('property', 'og:title', config.title);
      setMetaTag('name', 'twitter:title', config.title);
    }

    // 4. Update Canonical Link & OG URL
    const canonicalUrl = config.canonical || `https://isoret.com/${currentPage === 'home' ? '' : currentPage}`;
    setMetaTag('property', 'og:url', canonicalUrl);

    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute('href', canonicalUrl);

  }, [currentPage]);

  return null;
}
